import { SalaamahMarkLoaderSvg } from '@/shared/components/SalaamahMarkLoaderSvg';
import { messages } from '@/shared/i18n';

/**
 * Lazy-route fallback: Salaamah mark with staggered path motion (`globals.css`).
 */
export function RouteLoadingFallback() {
  const label = messages.common.routeLoading;

  return (
    <div
      className="flex min-h-dvh w-full flex-1 flex-col items-center justify-center gap-5 bg-surface-page px-6 py-16 font-sans"
      aria-busy
      aria-live="polite"
    >
      <div className="salaamah-loader-stage">
        <SalaamahMarkLoaderSvg />
      </div>
      <p className="salaamah-route-loading-label">{label}</p>
    </div>
  );
}
